import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

module.exports = {
  container: {
    paddingRight: 10,
    paddingLeft: __WEB__ ? 10 : 0,
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 1,
  },
  buttonContainer: {
    ...THEME.container,
    paddingVertical: 15,
    paddingRight: __WEB__ ? 0 : 5,
  },
  nameText: {
    ...THEME.textRegular,
    paddingHorizontal: 5,
  },
};
